import React from 'react'
import styled from 'styled-components';
import CircularProgress from '@material-ui/core/CircularProgress';

const Container = styled.div`

min-height:300px;
display:flex;
align-items:center;
justify-content:center;

`

const ActionFormLoadingEmptyState = props => {

    return(
        <Container>
            <CircularProgress/>
        </Container>
    );


}


export default ActionFormLoadingEmptyState;